/**
 * This must correspond with constants in backend App\Entity\AppConfig
 */
export enum AppConfigName {
    ILLEGAL_CHARS = 'illegal_chars',
    CHANNEL_METHOD = 'channel_method',
    MATCH_METHOD = 'match_method',
}
